import React from "react";

function HomePage() {
  return (
    <div className="About_main_wrapper mt-5 mb-5">
      <div className="container">
        <div className="row">
          <div className="col-md-5">
            <div className="img-wrap sticky top-[130px] self-start">
              <img class="img_width" src="/images/abt_left_img.svg" alt="About Us"></img>
            </div>
          </div>
          <div className="col-md-7">
            <div className="abt_side_text">
              <div class="section_main_title our_services">
                <p>About Us</p>
                <ul class="d-flex align-items-center">
                  <li class="green">experience </li>
                  <li class="orange">excellence</li>
                  <li class="light-blue">integrity</li>
                </ul>
                <h2>About  <span>Vanani</span>  Associates</h2>
                <div className="page_discriptions">
                  <p>Established in 2017, Vanani & Associates has quickly emerged as a prominent name in Gujarat's financial landscape. Founded by Nikunj Vanani, our firm combines the innovative drive of young professionals with the seasoned expertise of industry veterans. This dynamic balance allows us to deliver tailored, effective solutions across a wide range of financial services.</p>
                  <p>We provide expert consultancy in bookkeeping and accounting, auditing, tax advisory, GST, finance consultancy, statutory registrations and compliance, corporate laws, startup services, business advisory, CFO consultancy, remote staffing, and outsourcing. Our diverse offerings are designed to meet the unique needs of each client, ensuring personalized and prompt solutions.</p>
                  <p>Our motto, "Experience, Excellence, Integrity," reflects our dedication to upholding the highest standards of the profession. At Vanani & Associates, we are committed to maintaining ethical practices and delivering value-oriented services that drive sustainable growth.</p>
                  <p>Our team’s wealth of experience and broad expertise enables us to provide insightful and impactful solutions. We take pride in building lasting relationships with our clients, understanding their challenges, and delivering innovative solutions to help them succeed.</p>
                  <p>Vanani & Associates stands as a testament to our dedication, expertise, and unwavering commitment to excellence and integrity, making us a trusted partner for businesses across India and beyond.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container mt-5 mb-5">
        <div className="row justify-content-center">
          <div className="col-md-6 first_clr">
            <div className="content">
              <h4><img src="/images/vision.png" alt="Vision" width="70"></img><span className="pax-4 d-block mt-3">Vision</span></h4>
              <p>To be the most trusted and dynamic tax consultancy firm, empowering businesses to achieve their financial goals through innovative and ethical solutions. We aim to build a collaborative and inclusive environment where our talented team can thrive and provide exceptional value to our clients.</p>

            </div>
          </div>
          <div className="col-md-6 third_clr">
            <div className="content">
              <h4><img src="/images/focus.png" alt="Vision" width="70"></img><span className="pax-4 d-block mt-3"> Mission </span></h4>
              <p>Our mission is to build lasting relationships by providing personalized and innovative services that help clients navigate financial complexities with confidence. We uphold the highest standards of integrity and professionalism, embrace new technologies, and foster continuous learning to deliver cutting-edge solutions and comprehensive support.</p>
            </div>
          </div>
        </div>
      </div>

      {/* Value */}
      <div className="value_wrapper">
        <div className="container mt-3 pt-4">
          <div className="row">
            <div className="col-md-4 mb-5">
              <div className="box_design">
                <img src="/images/integration.png" alt="Integration" width="70"></img>
                <h5 className="mt-2 mb-2 light-blue">Integrity</h5>
                <p>We uphold the highest standards of integrity in all our dealings, ensuring transparency, honesty, and ethical practices. Our
                  commitment to these principles builds trust with our clients and fosters long-term relationships.</p>
              </div>
            </div>
            <div className="col-md-4 mb-5 text-center d-flex align-items-center justify-content-center flex-wrap center-div">
              <div className="center_content">
                <h2><strong><span className="light-blue">Our</span> Core <span className="orange">Values</span></strong></h2>
                <p className="mb-0">Our commitment to precision drives us to deliver reliable and tailored accounting solutions with exceptional quality.</p>
              </div>
            </div>
            <div className="col-md-4 mb-5">
              <div className="box_design">
                <img src="/images/respect.png" alt="Integration" width="70"></img>
                <h5 className="mt-2 mb-2 orange">Respect</h5>
                <p>We respect the diverse perspectives and contributions of all our team members and clients. By fostering a culture of
                  mutual respect, we create a positive and inclusive environment that encourages collaboration and growth.</p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="box_design">
                <img src="/images/commitment.png" alt="Integration" width="70"></img>
                <h5 className="mt-2 mb-2 orange">Commitment</h5>
                <p>Our commitment to our clients and our work is unwavering. We are dedicated to delivering high-quality services and solutions,
                  going above and beyond to meet our clients' needs and exceed their expectations.</p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="box_design">
                <img src="/images/confidentiality.png" alt="Integration" width="70"></img>
                <h5 className="mt-2 mb-2 green">Confidentiality</h5>
                <p>We prioritize the confidentiality of our clients' information, ensuring that their sensitive data is protected with the
                  utmost care and discretion. Our commitment to confidentiality builds trust and confidence in our services.</p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="box_design">
                <img src="/images/transparency.png" alt="Integration" width="70"></img>
                <h5 className="mt-2 mb-2 light-blue">Transparency</h5>
                <p>We believe in maintaining open and transparent communication with our clients. By being clear and honest in our interactions, we build strong
                  relationships based on trust and mutual understanding.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HomePage;
